export const STAR_ICON = "itaufonts_estrela";
export const STAR_FULL_ICON = "itaufonts_full_estrela";
export const HEART_ICON = "itaufonts_heart";
export const HEART_FULL_ICON = "itaufonts_heart_full";
//# sourceMappingURL=constants.js.map